import React, { useState } from 'react'
import PaginatedList from '../../screen-templates/paginated-list'
import Item from '../list-item'
import useReports from '../use-reports'

const ReportsPaginatedList = () => {
    const [ offset, setOffset ] = useState(0)
    const { isLoading, reports } = useReports()
    return (
        <PaginatedList
            items = {reports}
            pageSize={10}
            itemComponent={Item}
            total={0}
            offset={0}
            loading={isLoading}
            onOffsetChange={setOffset}
            noneFoundMessage='No reports found.'
        />
    )
}

export default ReportsPaginatedList